import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const channel: AdminBlockTypeAttribute = {
  label: 'Show channel',
  key: 'channel',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default channel;
